export default __webpack_public_path__ + "static/media/upload-fill.542da7ad.svg";